export default __webpack_public_path__ + "static/media/swedish_krona_red-sign.100049a1.svg";